import {useEffect} from "react";
import {useLocation} from "react-router-dom";

const WhenNavigate = () => {
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        /*// Show the loading screen
        const loadingScreen = document.getElementById("loading-wrapper");
        if (loadingScreen) {
            loadingScreen.style.display = "block";
        }
        // Hide the loading screen after a delay
        const timer = setTimeout(() => {
            if (loadingScreen) {
                loadingScreen.style.display = "none";
            }
        }, 2000); // Adjust the delay as needed
        return () => {
            clearTimeout(timer);
        };*/
    }, [pathname]);

    return null;
};

export default WhenNavigate;